import ATE from "./ActionTypeEnum";
import {combineReducers} from "redux";
import mainState from "./red-main";
import summaryState from "./pages/SummaryPage/state/red-summary";
import jobState from "./pages/JobPage/state/red-job";
import IAppState from "./IAppState";
import IReducers from "./IReducers";
import * as initialStates from "./initial-state";
import IInputFile from "./pages/SummaryPage/interfaces/IInputFile";
import ISummaryState from "./pages/SummaryPage/interfaces/ISummaryState";
import IMainState from "./IMainState";


const reducers: IReducers<IAppState> = {
    mainState,
    summaryState,
    jobState,
};

const rootReducer = combineReducers(reducers);

function reduce(
    state: IAppState = initialStates.initialState,
    action: {type: ATE, value?: any}
): IAppState {

    switch (action.type) {
        case ATE.SET_APP_STATE:
            return action.value;

        case ATE.SET_INITIAL_INPUT_STATE: {
            return {
                ...state,
                mainState: initialStates.mainInitialState,
            };
        }

        case ATE.LOAD_INPUT_FILE: {
            const data: IInputFile = action.value;

            const mainState: IMainState = (
                data.jobTitle !== undefined ? {
                    ...state.mainState,
                    jobTitle: data.jobTitle,
                } : state.mainState
            );

            return {
                ...state,
                mainState,
            };

        }

        case ATE.SUBMIT_INPUT: {
            const mainSt = state.mainState;
            const jobId = mainSt.jobId;
            const jobTitle = mainSt.jobTitle;
            const email = mainSt.email !== '' ? mainSt.email : null;
            const sequence = mainSt.sequence;
            
            let summaryState: ISummaryState;
            summaryState = {
                jobId, jobTitle, email, sequence,
                exampleJobId: null,
            };
            return {
                ...state,
                summaryState: summaryState,
            };
        }

        default:
            return rootReducer(state, action);
    }
}

export default reduce;
